import { useEffect } from "react";
import { useRouter } from "next/router";

const Page = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace("/tableau-de-bord");
  }, [router]);
  return <>Loading...</>;
};

export default Page;
